import { AkaStudentCoverage } from "Store/interfaces/products/coverage";
import { CountryCode } from "../ProductIntro/akaStudentProductIntroInterfaces";

export const coverageTypeFrom = (
  region: CountryCode | undefined,
): AkaStudentCoverage => {
  switch (region) {
    case CountryCode.NO:
      return AkaStudentCoverage.AKA_STUDENT_STANDARD;
    case CountryCode.NOR:
      return AkaStudentCoverage.AKA_STUDENT_ABROAD_NOR;
    case CountryCode.EU:
      return AkaStudentCoverage.AKA_STUDENT_ABROAD_EU;
    case CountryCode.AUS:
      return AkaStudentCoverage.AKA_STUDENT_ABROAD_AUS;
    case CountryCode.USA:
      return AkaStudentCoverage.AKA_STUDENT_ABROAD_USA;
    case CountryCode.OTHER:
    default:
      return AkaStudentCoverage.AKA_STUDENT_ABROAD_OTHER;
  }
};
